import { computed, Ref } from "vue";
import { MstSyouninGroup } from "@/types/SyouninGroup"

export function useTabError(form: Ref<MstSyouninGroup>) {
  // 打刻タブの確認
  const isErrorDakoku = computed(() => {
    // if (form.value.main) {
    //   if (form.value.main.errors && Object.keys(form.value.main.errors).length > 0) {
    //     //       return true
    //   }
    // }
    return false
  })

  return {
    isErrorDakoku,
  }
}
